import { DrQuoteSection, DrQuoteSectionProps } from 'components/sections/DrQuotes/index'
import { FC } from 'react'

export const DrAlineQuote: FC<Partial<DrQuoteSectionProps>> = (props) => {
  return (
    <DrQuoteSection
      quoteText="Os cuidados com a pele impactam diretamente na autoestima. Uma pele bem cuidada pode ajudar no processo de autoestima, autocuidado e amor próprio."
      doctorName="Dra. Aline Erthal"
      credentials={['Universidade de São Paulo', 'Sociedade Brasileira de Dermatologia']}
      councilRegistryNo="CRM SP 199764"
      {...props}
    />
  )
}
